import React from 'react'
import Container from 'muicss/lib/react/container'
import ListHeaderNav from './ListHeaderNav'
import ItemList from './ItemList.jsx'

const Featured = ({ featured, items, images }) => (
  <div>
    <div className="list-header --water">
      <Container>
        <ListHeaderNav link="/featured" text="特集一覧へ戻る" />
        <div className="list-header__content">
          <h1 className="list-header__title"></h1>
          <p className="list-header__description"></p>
          <i className="list-header__date"></i>
        </div>
      </Container>
    </div>
    <ItemList data={items} images={images} />
  </div>
)

export default Featured



// WEBPACK FOOTER //
// ./src/components/Featured.js